import { useState, useEffect } from 'react'
import { useDropzone } from 'react-dropzone'
import { formatBytes } from '../../../../../infra/helpers/size';
import { Botao } from '../../../../../shared/components/Botao';
import { useGetArquivoToken } from '../../../hooks/useGetArquivos';
import usePutArquivo from '../../../hooks/usePutArquivos';
import { CreateModal } from '../../../../../shared/components/Modal';

interface UploadePropos {
  isOpen: boolean;
  setIsOpen: ( setIsOPen: any) => void;
  ClienteId: number;
}

export function Upload({ isOpen, setIsOpen, ClienteId} : UploadePropos) {

  const [arq, setArq] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const {data: token} = useGetArquivoToken(ClienteId, arq)

  function closeModal() {
    setIsOpen(!isOpen)
    setIsLoading(false)
  }

  const { mutate: enviarArquivo } = usePutArquivo(closeModal, () => setIsLoading(false))
  
  const {getRootProps, getInputProps, open, acceptedFiles} = useDropzone({
    noClick: true,
    noKeyboard: true,
    maxFiles: 1
  });
  
  const files = acceptedFiles.map((file : any) => (
    <li key={file?.path}>
      {file?.path} - {formatBytes(file?.size)}
    </li>
  ));
  
  useEffect(() => {
    acceptedFiles && setArq(acceptedFiles)    
  }, [acceptedFiles])

  
  async function onSubmit(e : any){
    e.preventDefault()
    try {
      navigator.onLine && await enviarArquivo({
        token, 
        arq,
        ClienteId
      })
      setIsLoading(true)
    }
    catch {}
  }

  return (
    <CreateModal
        title="Upload de arquivo"
        isModalOpen={isOpen}
        onSubmit={onSubmit}
        onCancel={() => {
          setIsOpen(!isOpen)
        }}
        isLoading={isLoading}
        children={
          <div>
            <h2 className="font-bold mb-2">Adicionar um novo arquivo</h2>
            <form>
              <div className="container">
                <div className="flex flex-col border-dashed border-2 p-4 justify-center bg-gray-50">
                  <div {...getRootProps({className: 'dropzone'})}>
                    <input {...getInputProps()} />
                    <p className="text-center">Arraste algum arquivo pra cá e solte aqui</p>
                    <div className="flex pt-4 justify-center">
                      <Botao type="button" onClick={open} texto="Selecionar arquivo" className='bg-primary text-white' />
                    </div>
                  </div>
                </div>
                <aside>
                  <h4 className="pt-2">Arquivos</h4>
                  <ul className="pb-2">{files}</ul>
                </aside>
              </div>
            </form>
          </div>
        }
      />
  );
}